import * as ActionIds from "../constants/codingAdvices";

import type { CodingAdvicesActions } from "../actions/codingAdvices";
import type { CodingAdvicesState } from "../models/codingAdvices";

const EMPTY_CODING_ADVICES_STATE: CodingAdvicesState = {
  filter: {
    encounterType: null,
    facility: null,
    codeType: null,
    itemType: null,
    top: 20,
    search: "",
    skip: 0,
    order: [{ field: "Advice", asc: true }],
  },
  busy: 0,
  advices: null,
  codes: {},
};

export function codingAdvicesReducer(
  state: CodingAdvicesState = EMPTY_CODING_ADVICES_STATE,
  action: CodingAdvicesActions,
): CodingAdvicesState {
  switch (action.type) {
    case ActionIds.CODINGADVICES_END_WAIT:
      if (state.busy <= 0) {
        console.error("CODINGADVICES_END_WAIT happens more than CODINGADVICES_BEGIN_WAIT");
        return state;
      }
      return {
        ...state,
        busy: state.busy - 1,
      };
    case ActionIds.CODINGADVICES_BEGIN_WAIT:
      return {
        ...state,
        busy: state.busy + 1,
      };
    case ActionIds.CODINGADVICES_UPDATE_CODINGADVICES:
      return {
        ...state,
        filter: action.filter,
        advices: action.codingAdvices,
      };
    case ActionIds.CODINGADVICES_UPDATE_CODES:
      return {
        ...state,
        codes: { ...state.codes, [action.id]: action.codes },
      };
    default:
      return state;
  }
}
